export default __webpack_public_path__ + "static/media/5436.58bce2f0.png";